export default __webpack_public_path__ + "static/media/bg3.cd8b2bf2.png";